module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-800.8f621673.woff";